module.exports = __webpack_public_path__ + "static/augusta-2e80d54ac132e8836d1758409a911312.jpg";